<template>
    <header class="container header">
        <img class="shape-drop-main" src="@/assets/img/shape-drop-main.svg">
        <div class="header-group">
          <h1 class="header__h1">
              <img src="@/assets/img/logo.svg" alt="Beautizon">
          </h1>
          <button class="header__menu-btn" @click="$emit('open-nav')">
              <img src="@/assets/img/menu-btn.svg">
          </button>
        </div>
    </header>
</template>

<script>
export default {
  props: ['showNav']
}
</script>

<style lang="scss">
@import '@/assets/css/helpers-variables.scss';

.shape-drop-main {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 37.5%;
  min-width: 240px;
  background-size: cover;
  z-index: -1;
  max-width: 720px;
}

.header {
  position: relative;
  padding-top: 30px;
  margin-bottom: 50px;
  @media (min-width: $laptop-s) {
    margin-bottom: 40px;
  }
  @media (min-width: $laptop-l) {
    margin-bottom: 80px;
  }
}

.header-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__h1 {
  width: 130px;
  float: left;
  img {
    display: block;
  }
  @media (min-width: $laptop-s) {
    min-width: 230px;
  }
}

.header__menu-btn {
  float: right;
  cursor: pointer;
}
</style>
